export default __webpack_public_path__ + "static/media/See_more.0f1b380a.svg";